import React from 'react';
import { useHostAppProxy, ProxyEventTypes } from '../../../contexts/HostAppProxyContext';

interface SocialProfileLinksProps {
  socialProfiles?: {
    goodreads?: string;
    tome?: string;
    instagram?: string;
    tiktok?: string;
  };
  style?: React.CSSProperties;
  disabled?: boolean;
}

const SocialProfileLinks: React.FC<SocialProfileLinksProps> = ({
  socialProfiles,
  style,
  disabled = false,
}) => {
  const { settings, sendMessageToHost } = useHostAppProxy();
  if (!socialProfiles || Object.values(socialProfiles).every(url => !url)) {
    return null;
  }

  const profileConfig = [
    {
      platform: 'goodreads',
      name: 'Goodreads',
      label: 'Goodreads Profile',
    },
    {
      platform: 'tome',
      name: 'Tome',
      label: 'Tome Profile',
    },
    {
      platform: 'instagram',
      name: 'Instagram',
      label: 'Instagram Profile',
    },
    {
      platform: 'tiktok',
      name: 'TikTok',
      label: 'TikTok Profile',
    },
  ];

  return (
    <div style={{ marginTop: '4px', ...style }}>
      {profileConfig.map(({ platform, name, label }) => {
        const url = socialProfiles[platform as keyof typeof socialProfiles];
        if (!url) return null;

        if (disabled) {
          return <span key={platform} className="br-social-profile-link">{name}</span>;
        }

        return (
          <a
            key={platform}
            className="br-social-profile-link"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Visit ${label}`}
            onClick={event => {
              if (window.ReactNativeWebView || settings.isWrapped) {
                event.preventDefault();
                sendMessageToHost({
                  type: ProxyEventTypes.OPEN_EXTERNAL_URL,
                  data: {url},
                });
              }
            }}
          >{name}</a>
        );
      })}
    </div>
  );
};

export default SocialProfileLinks;
